import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';

const AutoRedirect = ({ children }) => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  useEffect(() => {
    // قائمة الصفحات المتاحة مرتبة حسب الأولوية
    const availablePages = [
      { path: '/', permission: 'view-dashboard' },
      { path: '/roles', permission: 'view-roles' },
      { path: '/admins', permission: 'view-admins' },
      { path: '/users', permission: 'view-users' },
      { path: '/category', permission: 'view-categories' },
      { path: '/contacts', permission: 'view-contacts' },
      { path: '/hero', permission: 'view-sliders' },
      { path: '/about-us', permission: 'manage-settings' },
      { path: '/sections', permission: 'view-sections' },
      { path: '/slider-texts' },
      { path: '/study-materials', permission: 'view-subjects' },
      { path: '/grades', permission: 'view-grades' },
      { path: '/products', permission: 'view-products' },
      { path: '/orders', permission: 'view-orders' },
      { path: '/teachers', permission: 'view-teachers' },
      { path: '/regions', permission: 'view-regions' },
      { path: '/cities', permission: 'view-cities' },
      { path: '/features', permission: 'view-features' },
      { path: '/faqs', permission: 'view-faqs' },
      { path: '/messages', permission: 'view-messages' }
    ];

    // البحث عن أول صفحة متاحة للمستخدم
    const firstAvailablePage = availablePages.find(page => hasPermission(page.permission));
    
    if (firstAvailablePage) {
      // إذا كان المستخدم في الصفحة الرئيسية ولا يملك صلاحية view-dashboard
      if (window.location.pathname === '/' && !hasPermission('view-dashboard')) {
        navigate(firstAvailablePage.path, { replace: true });
      }
    }
  }, [navigate, hasPermission]);

  return children;
};

export default AutoRedirect;
